import * as React from 'react';
import { IconProps } from '~/components/atoms/icon/iconProps';

const BarsFilterIcon: React.FC<IconProps & React.SVGProps<SVGSVGElement>> = ({
    width = 24,
    height = 24,
    fill = 'currentColor',
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" aria-hidden="true">
            <path fill={fill} d="M6,13H18V11H6M3,6V8H21V6M10,18H14V16H10V18Z" />
        </svg>
    );
};

export default BarsFilterIcon;
